import React, { useContext } from 'react';
import { Col, Container, Row } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import OperationContext from '../../context';
import { PageHeader, Section } from '../../../../../shared/components';
import Role from '../../../../../types/role';
import Context from '../../../../App/MainProvider/context';

const FinancialForm: React.FC = () => {
  const { t } = useTranslation();
  const { operation } = useContext(OperationContext);
  const { user, inSuperUserMode } = useContext(Context);

  const canContinue =
    operation.isMember ||
    user.roleCode === Role.GroupHead ||
    user.roleCode === Role.HSO ||
    inSuperUserMode() ||
    (operation.belongsGS && user.isGuidanceService);

  return (
    <Container className="dashboard">
      <PageHeader title={`Operation ${operation.number} / Toolkit`} backTimes={1} />

      <Section title={t('financialFormSubtitle')}>
        <Row>
          <Col md={4}>
            <div className="toolkit-fi-item">
              <h5>{t('financialFormFITitle')}</h5>
              <p>{t('financialFormFIDescription')}</p>
              {canContinue && (
                <Link to={`/operations/${operation.number}/toolkit/espf/form/fi`}>
                  {t('financialFormGoToTheQuestions')}
                </Link>
              )}
            </div>
          </Col>
          <Col md={4}>
            <div className="toolkit-fi-item">
              <h5>{t('financialFormTcpoTitle')}</h5>
              <p>{t('financialFormTcpoDescription')}</p>
              {canContinue && (
                <Link to={`/operations/${operation.number}/toolkit/espf/form/tcpo`}>
                  {t('financialFormGoToTheQuestions')}
                </Link>
              )}
            </div>
          </Col>
          <Col md={4}>
            <div className="toolkit-fi-item">
              <h5 style={{ fontSize: '16px' }}>{t('financialFormOtherTitle')}</h5>
              <p>{t('financialFormOtherDescription')}</p>
              {canContinue && (
                <Link to={`/operations/${operation.number}/toolkit/espf/form/other`}>
                  {t('financialFormGoToTheQuestions')}
                </Link>
              )}
            </div>
          </Col>
        </Row>
      </Section>
    </Container>
  );
};

export default FinancialForm;
